<template>
  <div id="contact">
    <div v-html="content"></div>
  </div>
</template>

<script>
import {reContent} from '@/assets/utility'

export default {
  data() {
    return {
      content: ''
    }
  },
  mounted() {
    this.$store.commit('setAboutTabI', 3)
    this.$axios.post('about/getContact').then((res)=>{
      if (res) {
        this.content= reContent(res.content)
      }
    })
  }
}
</script>
